/** @module Apparel/_ColorMaterialFormMixin **/
define([
		"dojo/_base/declare",
		"dojo/_base/lang",
		"csi",
		"csi/def",
		"csi/def/Field",
		"csi/form/Widget",
		"csi/locale",
		"csi/reflection",
		"csi/sessionConstants",
		"csi/xml",
		"Apparel/ColorPalette/ColorForm",
], function(declare,lang,csi,def,Field,Widget,locale,reflection,sessionConstants,xml,ColorForm) {
	
	return declare(ColorForm, {

		/**
		 * Decides if checkbox should be shown or hidden
		 */
		_resolveView: function() {

			var showCheckbox = true;
			var formData = this.getFormData();
			var formAction = formData.getAction();

			// When editing a color material with a default 3D material, that 3D material is automatically recolored
			// if a different color spec is selected. No checkbox needed.
			if (formAction?.getId() == "Edit") {
				var colorMatNode = this.cacheView.getNode(this.urlRoot);
				showCheckbox = colorMatNode && colorMatNode.Default3DMaterial == csi.EMPTY_URL;
			} else if (formAction?.getId() == "NewFromColorPalette") {
				// on the NewFromColorPalette form, we should be basing off a new ColorMaterial, not the ColorInPalette
				this.urlRoot = null;
			}

			if (showCheckbox && sessionConstants.allow3d) {
				var parentURL = formData.m_source.m_urlParent;
				var parentNode = this.cacheView.getNode(parentURL);

				// On site level color materials, another method is required to find the parent node
				if(parentNode && parentNode.$Type == "_CS_ApparelViews") {
					parentURL = this.urlRoot;
					parentNode = this.cacheView.getNode(parentURL);
				} else if(parentNode && (parentNode.$Type == "MaterialPlanPlacementColorway" || parentNode.$Type == "MaterialPlanPlacement")) {
					parentNode = this.cacheView.getNode(parentNode.MPCMaterial) || this.cacheView.getNode(parentNode.Actual);
				}
			}
			this.inherited(arguments);
		}
	});
});
